/**
 * Helpers para o filtro de Zona de Entrega.
 *
 * Uma zona de entrega agrupa cidades dentro de um Operador Logístico. Uma entrega
 * pertence a uma zona quando a cidade do cliente da entrega está associada àquela zona.
 */

export function buildZonasEntregaOptions(zonasEntrega) {
  return (zonasEntrega || [])
    .filter(zona => zona.actived)
    .map(zona => ({ label: zona.name, value: zona.id }))
}

/**
 * Retorna um Set com os ids das cidades pertencentes às zonas selecionadas.
 */
export function buildCityIdsFromZonas(zonasEntrega, selectedZonasIds) {
  const cityIds = new Set()
  if (!selectedZonasIds || !selectedZonasIds.length) return cityIds

  ;(zonasEntrega || [])
    .filter(zona => selectedZonasIds.includes(zona.id))
    .forEach(zona => (zona.cities || []).forEach(city => cityIds.add(city.id)))

  return cityIds
}
